import React from 'react';
import mixpanel from 'mixpanel-browser';
import { User } from '@workos-inc/authkit-react';

type TrackType = typeof mixpanel.track;

type MixpanelContextType = {
  init: () => void;
  track: TrackType;
  identify: (user: User) => void;
};

export const MixpanelContext = React.createContext<MixpanelContextType>({
  init: () => {},
  track: () => {},
  identify: () => {},
});
